import { render } from "./ClientsBlocked.vue?vue&type=template&id=120b4366"
import script from "./ClientsBlocked.vue?vue&type=script&lang=js"
export * from "./ClientsBlocked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__